<template>
    <div>
        <el-dialog v-dialogDrag :title="`${name}的二维码`" :visible.sync="centerDialogVisible" width="500px" center
            :before-close="close">
            <div class="qrcode">
                <vue-qrcode :value="value" @change="onDataUrlChange" :width="300" :height="300"
                    :color="{ dark: '#000000', light: '#ffffff' }" type="image/png" v-show="false" />
                <img :src="dataUrl" alt="qrcode" />
                <div class="show-id">ID: {{ id }}</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="success" @click="handleDownload">下 载</el-button>
                <el-button type="primary" @click="onSendCard">分 享</el-button>
            </span>
        </el-dialog>
        <chat-selector ref="chatSel" title="转发消息"></chat-selector>
    </div>
</template>
<script>
import VueQrcode from 'vue-qrcode';
import ChatSelector from "../chat/ChatSelector.vue";

export default {
    data() {
        return {
            dataUrl: null,
            centerDialogVisible: true,
        }
    },
    props: {
        isGroup: {
            type: Boolean,
            default: false,
        },
        id: {
            type: Number,
            default: 0,
        },
        name: {
            type: String,
            default: '',
        },
        headImage: {
            type: String,
            default: '',
        },
    },
    components: {
        VueQrcode,
        ChatSelector
    },
    methods: {
        onDataUrlChange(dataUrl) {
            this.dataUrl = dataUrl
        },
        close() {
            this.$emit('close')
        },
        handleDownload() {
            // 创建一个新的<a>元素
            var link = document.createElement("a");

            // 创建一个URL对象，指向Blob对象
            link.href = this.dataUrl;

            // 设置下载的文件名
            link.download = `qrcode_${this.id}.png`;

            // 将<a>元素添加到DOM中
            document.body.appendChild(link);

            // 触发点击事件来开始下载
            link.click();

            // 从DOM中移除<a>元素
            document.body.removeChild(link);
            this.close();
        },
        onSendCard() {
            let message = {
                content: JSON.stringify({
                    userId: this.id,
                    nickName: this.name,
                    headImage: this.headImage,
                }),
                type: this.$enums.MESSAGE_TYPE.USER_CARD,
                recvId: '',
            }
            if (this.isGroup) {
                message = {
                    content: JSON.stringify({
                        groupId: this.id,
                        groupName: this.name,
                        headImage: this.headImage,
                    }),
                    type: this.$enums.MESSAGE_TYPE.GROUP_CARD,
                    groupId: '',
                }
            }

            this.$refs.chatSel.open(chats => {
                // 逐个会话发送消息
                let idx = 0;
                chats.forEach(chat => {
                    if (chat.type == 'GROUP') {
                        message.groupId = chat.targetId
                    } else {
                        message.recvId = chat.targetId;
                    }
                    this.$http({
                        url: `/message/${chat.type.toLocaleLowerCase()}/send`,
                        method: 'post',
                        data: message
                    }).then((m) => {
                        m.selfSend = true;
                        this.$store.commit("openChat", chat);
                        this.$store.commit("insertMessage", [m, chat]);
                        if (++idx == chats.length) {
                            this.$message.success("转发成功")
                            this.close();
                        }
                    })
                })
            });
        },
    },
    computed: {
        value() {
            let str = `/?scan=1&`
            if (this.isGroup) {
                str += `groupId=${this.id}`
            } else {
                str += `userId=${this.id}`
            }
            return str
        }
    }
}
</script>

<style scoped lang="scss">
.qrcode {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .show-id {
        font-size: 1.2rem;
        font-weight: bold;
    }
}
</style>